export default "__VITE_ASSET__D$bWQA1U__"